import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import color from "./Colors";

interface CircularProgressWithLabelProps {
  value: number;
  size: number;
  fontSize: number;
  textcolor: string;
  circlecolor: string;
  label?: string;
}

const CircularProgressWithLabel: React.FC<CircularProgressWithLabelProps> = ({
  value,
  size,
  fontSize,
  textcolor,
  label,
  circlecolor,
}) => {
  return (
    <Box
      position="relative"
      width={size}
      height={size + 50} // increase height to make room for label
    >
      <CircularProgress
        size={size}
        sx={{ position: "absolute" }}
        variant="determinate"
        value={100}
        style={{ color: color.secondColor }}
      />
      <CircularProgress
        size={size}
        variant="determinate"
        value={value}
        sx={{ color: circlecolor }}
      />
      <Box
        top={0}
        left={8}
        bottom={50}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          fontWeight={"bold"}
          fontSize={fontSize}
          variant="caption"
          component="div"
          color={textcolor}
        >{`${Math.round(value)}%`}</Typography>
      </Box>
      <Box
        position="absolute"
        top={size + 8} 
        left={0}
        width="100%"
        display="flex"
        justifyContent="center"
      >
        <Typography
          fontSize={fontSize}
          variant="caption"
          textAlign="center"
          sx={{
            color: color.firstColor,
            fontWeight: "bold",
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
